import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-gengduo",
  "use": "icon-gengduo-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-gengduo\"><path d=\"M279.063063 1019.387387c-13.837838 0-23.063063-4.612613-32.288288-13.837838-18.45045-18.45045-18.45045-46.126126 0-64.576577l428.972973-428.972973L246.774775 87.63964c-18.45045-18.45045-18.45045-46.126126 0-64.576577s46.126126-18.45045 64.576577 0l461.261261 461.261261c18.45045 18.45045 18.45045 46.126126 0 64.576577l-461.261261 461.261261C306.738739 1014.774775 292.900901 1019.387387 279.063063 1019.387387z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/gengduo.svg
// module id = wkfg
// module chunks = 16